<section class="descontos-produto">
  <h4>Descontos por forma de pagamento</h4>
  <p *ngIf="carregando" role="status">Carregando formas de pagamento...</p>
  <div class="descontos-erro" *ngIf="erroCarregamento" role="alert">
    {{erroCarregamento}}
    <button type="button" class="btn btn-link" (click)="recarregar.emit()">Tentar novamente</button>
  </div>

  <ng-container *ngIf="!carregando && !erroCarregamento">
    <div class="desconto-forma" *ngFor="let linha of linhas">
      <div class="desconto-linha">
        <label class="desconto-check">
          <input type="checkbox" [(ngModel)]="linha.ativo" [ngModelOptions]="{standalone: true}"
                 [disabled]="!podeEditar || salvando" (ngModelChange)="alterou()"
                 [attr.aria-label]="'Aplicar desconto de ' + linha.descricao + ' neste produto'">
          <span>{{linha.descricao}}</span>
        </label>
        <span class="desconto-padrao">Padrão: {{linha.percentualPadrao | number:'1.0-2'}}%</span>
        <span class="desconto-especifico" *ngIf="linha.ativo && linha.percentual != null">Neste produto: {{linha.percentual | number:'1.0-2'}}%</span>
        <button type="button" class="btn btn-link btn-sm" [disabled]="!linha.ativo || !podeEditar || salvando"
                [attr.aria-expanded]="editando.includes(linha.formaDePagamentoId)"
                [attr.aria-label]="'Editar desconto de ' + linha.descricao" (click)="editarPercentual(linha)">
          {{editando.includes(linha.formaDePagamentoId) ? 'Fechar' : 'Editar'}}
        </button>
      </div>
      <div class="desconto-edicao" *ngIf="linha.ativo && editando.includes(linha.formaDePagamentoId)">
        <label [for]="'percentualEspecial' + produtoId + '-' + linha.formaDePagamentoId">Desconto neste produto (%)</label>
        <kendo-numerictextbox [id]="'percentualEspecial' + produtoId + '-' + linha.formaDePagamentoId"
          [min]="0.1" [max]="100" [decimals]="2" [format]="'n2'"
          [(ngModel)]="linha.percentual" [ngModelOptions]="{standalone: true}"
          [disabled]="!podeEditar || salvando" (ngModelChange)="alterou()"
          [placeholder]="'Padrão: ' + linha.percentualPadrao + '%'">
        </kendo-numerictextbox>
        <button type="button" class="btn btn-link btn-sm" [disabled]="!podeEditar || salvando"
                (click)="usarPadrao(linha)">Usar padrão</button>
      </div>
    </div>
    <p class="descontos-erro mt-2 mb-0" *ngIf="erro" role="alert">{{erro}}</p>
  </ng-container>
</section>
